import {
  getAuth,
  onAuthStateChanged,
  User as FirebaseUser,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { query, orderBy } from "firebase/firestore";
import { Collection } from "firestorter";
import { observable, runInAction } from "mobx";

import Store from "..";
import GeneralStore from "../general/store";
import User from "./user";

export { default as User } from "./user";

class AuthStore extends GeneralStore {
  private loaded = observable.box(false);
  private _user = observable.box<User | undefined>();

  constructor(store: Store) {
    super(store);
    const auth = getAuth();
    onAuthStateChanged(auth, this.updateUser);
  }

  get isLoaded() {
    return this.loaded.get();
  }

  get isSignedIn() {
    return !!this.user;
  }

  get user() {
    return this._user.get();
  }

  users = new Collection("user", {
    createDocument: (source, options) => new User(source, options, this.store),
    query: (ref) => query(ref, orderBy("lastname")),
  });

  signInWithEmail = async (credentials: {
    email: string;
    password: string;
  }) => {
    const auth = getAuth();
    await signInWithEmailAndPassword(
      auth,
      credentials.email,
      credentials.password
    );
  };

  private updateUser = (currentUser?: FirebaseUser | null) => {
    runInAction(() => {
      if (currentUser) {
        const user = new User(`user/${currentUser.uid}`, {}, this.store);
        this._user.set(user);
      } else {
        this._user.set(undefined);
      }
      this.loaded.set(true);
    });
  };
}

export default AuthStore;
